"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AccountsListAdmin_module_css_1 = __importDefault(require("./AccountsListAdmin.module.css"));
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var material_1 = require("@mui/material"); //
var q_play_components_1 = require("@nordicscreen/q-play-components");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var styles_1 = require("@mui/material/styles");
var theme = __assign(__assign({}, RAStyles_1.RaDatagridTheme), { components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: "var(--info-color)",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "var(--info-color)",
                    "&.Mui-focused": {
                        color: "var(--primary-color)",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--primary-color)",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--primary-color)",
                    },
                },
            },
        },
    }, sidebar: {
        width: 0,
        closedWidth: 0,
    } });
var RaDomainDataGridSx = {
    "& .RaDatagrid-table": {
        marginTop: "0px"
    },
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--secondary-color-tinted)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "15px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: "15px",
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    }
};
var AddDomainField = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(false), openAddModal = _a[0], setOpenAddModal = _a[1];
    var _b = (0, react_1.useState)(""), newDomain = _b[0], setNewDomain = _b[1];
    var _c = (0, react_1.useState)(""), accountId = _c[0], setAccountId = _c[1];
    var _d = (0, react_1.useState)(""), error = _d[0], setError = _d[1];
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var handleOpenAddModal = function () { return setOpenAddModal(true); };
    var handleCloseAddModal = function () {
        setOpenAddModal(false);
        setNewDomain("");
        setAccountId("");
        setError("");
    };
    var handleAddDomain = function () { return __awaiter(void 0, void 0, void 0, function () {
        var numericAccountId, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    numericAccountId = Number(accountId);
                    if (isNaN(numericAccountId) || numericAccountId <= 0) {
                        setError(t("Invalid Account ID."));
                        return [2 /*return*/];
                    }
                    else if (!newDomain) {
                        setError(t("Domain is missing."));
                        return [2 /*return*/];
                    }
                    else {
                        setError("");
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.addDomainToAccount(numericAccountId, newDomain)];
                case 2:
                    _a.sent();
                    refresh();
                    handleCloseAddModal();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Adding domain failed", error_1);
                    setError(t("Error occurred while adding the domain."));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-flex align-items-center", style: { justifyContent: "flex-end" } },
            react_1.default.createElement(q_play_components_1.Button, { size: "small", variant: "primary", onClick: handleOpenAddModal, text: t("New Domain"), "data-cy": "addDomainButton", style: { marginBottom: "20px" } })),
        react_1.default.createElement(material_1.Dialog, { open: openAddModal, onClose: handleCloseAddModal, "data-cy": "newDomainDialog" },
            react_1.default.createElement(material_1.DialogTitle, { sx: {
                    fontFamily: "Geomanist-Bold",
                    color: "var(--info-color)",
                } }, t("Add New Domain")),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
                    react_1.default.createElement("div", { style: { display: "flex", gap: "20px" } },
                        react_1.default.createElement(material_1.TextField, { margin: "dense", id: "account-id", label: t("Account ID"), type: "text", style: { flex: 1 }, value: accountId, onChange: function (e) { return setAccountId(e.target.value); }, "data-cy": "accountIdInputField" }),
                        react_1.default.createElement(material_1.TextField, { margin: "dense", id: "new-domain", label: t("Domain"), type: "text", style: { flex: 3 }, onChange: function (e) { return setNewDomain(e.target.value); }, "data-cy": "newDomainInputField", fullWidth: true })))),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between", gap: "90px" } },
                    error && (react_1.default.createElement("div", { style: { color: "#a71535", marginTop: "10px", flex: 1 } }, error)),
                    react_1.default.createElement("div", { style: { display: "flex", gap: "10px" } },
                        react_1.default.createElement(q_play_components_1.Button, { onClick: handleCloseAddModal, size: "small", variant: "cancel" }, t("Cancel")),
                        react_1.default.createElement(q_play_components_1.Button, { onClick: handleAddDomain, size: "small", variant: "primary", disabled: newDomain === "" || accountId === "", "data-cy": "addNewDomainButton" }, t("Add"))))))));
};
var RemoveDomainField = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var handleRemoveDomain = function () { return __awaiter(void 0, void 0, void 0, function () {
        var domainLockId, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    domainLockId = Number(record.id);
                    if (isNaN(domainLockId)) {
                        logger.error("Invalid domain lock ID.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.deleteDomainLock(domainLockId)];
                case 2:
                    _a.sent();
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    logger.error("Error deleting domain lock:", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (!record)
        return;
    return (react_1.default.createElement("div", { onClick: handleRemoveDomain, style: { cursor: "pointer" } },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, title: t("Remove domain"), className: AccountsListAdmin_module_css_1.default["delete-icon"], "data-cy": "removeDomainButton" })));
};
var DomainListView = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", { style: { width: "400px" } },
        react_1.default.createElement("h1", { className: "ns-font-family-bold ".concat(AccountsListAdmin_module_css_1.default["header-text"]) }, t("Domains listing")),
        react_1.default.createElement("h6", { className: AccountsListAdmin_module_css_1.default["header-text"] }, t("Shows all domains")),
        react_1.default.createElement(react_admin_1.Admin, { theme: theme, dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "domainLock", list: react_1.default.createElement(react_admin_1.ListBase, null,
                    react_1.default.createElement(AddDomainField, null),
                    react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RaDomainDataGridSx, bulkActionButtons: false, "data-cy": "domainListAdminTable" },
                        react_1.default.createElement(react_admin_1.TextField, { source: "account_id", label: t("Account ID"), sortable: true, "data-cy": "domainAccountIdRow" }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "domain", label: t("Domain"), sx: { fontFamily: "Geomanist-bold" }, "data-cy": "domainNameRow", sortable: false }),
                        react_1.default.createElement(RemoveDomainField, null)),
                    react_1.default.createElement(Pagination_1.default, null)) }))));
};
exports.default = DomainListView;
